import {OperationTypes} from '@jimmyn/apollo-client';
import {Button, Modal, Space} from 'antd';
import {
  CancelSubscriptionInput,
  SubscriptionFieldsFragment,
  useCancelSubscriptionMutation
} from 'api/generated';
import {subscriptionQuery} from 'api/queries';
import {Formik} from 'formik';
import {Form, FormItem, Radio} from 'formik-antd';
import {FormikHelpers} from 'formik/dist/types';
import {formatUnixDate} from 'lib/formaters';
import React, {useState} from 'react';

type Props = {subscription: SubscriptionFieldsFragment};

export const CancelSubscription: React.FC<Props> = ({subscription}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [cancelSubscription] = useCancelSubscriptionMutation({
    updateQuery: {query: subscriptionQuery, variables: {subscriptionId: subscription?.id}},
    operationType: OperationTypes.UPDATE
  });

  const initialValues: CancelSubscriptionInput = {
    id: subscription.id,
    accountId: subscription.accountId,
    cancelAtPeriodEnd: true
  };

  const handleCancel = async (
    input: CancelSubscriptionInput,
    {setSubmitting}: FormikHelpers<CancelSubscriptionInput>
  ) => {
    try {
      await cancelSubscription({variables: {input}});
      setIsOpen(false);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Button onClick={() => setIsOpen(true)}>Cancel</Button>
      <Formik initialValues={initialValues} onSubmit={handleCancel}>
        {({submitForm, isSubmitting, resetForm}) => (
          <Modal
            title="Cancel subscription"
            okText="Cancel subscription"
            cancelText="Never mind"
            open={isOpen}
            confirmLoading={isSubmitting}
            onOk={submitForm}
            onCancel={() => {
              setIsOpen(false);
              setTimeout(resetForm, 100);
            }}>
            <Form layout="vertical">
              <FormItem name="cancelAtPeriodEnd">
                <Radio.Group name="cancelAtPeriodEnd">
                  <Space direction="vertical">
                    <Radio value={true} name="cancelAtPeriodEnd">
                      Cancel at the current period end (
                      {formatUnixDate(subscription.currentPeriodEnd)})
                    </Radio>
                    <Radio value={false} name="cancelAtPeriodEnd">
                      Cancel immediately
                    </Radio>
                  </Space>
                </Radio.Group>
              </FormItem>
              <input type="submit" value="submit" hidden />
            </Form>
          </Modal>
        )}
      </Formik>
    </>
  );
};
